import { matchPath } from "react-router-dom";
import { agentRouteConfig } from "./AgentRouteConfig";

export const getAgentRouteInfo = (pathname) => {
  for (const route in agentRouteConfig) {
    const match = matchPath({ path: route, end: true }, pathname);
    if (match) {
      return agentRouteConfig[route];
    }
  }

  return {
    pageTitle: "",
    breadcrumbs: [],
  };
};
